import React, {useEffect, useState} from 'react';
import {Card, Dropdown} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {deleteDevice, openModal, setDeleteModalStatus, setDevice} from "../../redux-store/devices";
import {getDeviceDeleteModalStatus, getDeviceLoader, getDevices, installationSelect} from "../../redux-store/selectors";
import AppLoader from "../ApplicationComponent/Loader";
import ellipsis from "../../images/ellipsis-h.png";
import {AiFillEdit} from "react-icons/ai";
import {RiDeleteBin6Line} from "react-icons/ri";
import {CustomDropDownToggle} from "./Devices";
import PlusIcon from "../../images/plusicon.png";
import DeviceModal from "./DeviceModal";
import {letterSpace} from "../../constants/FunctionJS";
import ConfirmationModal from "./ConfirmationModal";

const DeviceAccordionBody = ({locationId, activeKey}) => {

    const dispatch = useDispatch();

    const devices = useSelector(getDevices);
    const loading = useSelector(getDeviceLoader);
    const installation = useSelector(installationSelect);
    const showConfirmationModal = useSelector(getDeviceDeleteModalStatus);
    const [selectedDevice, setSelectedDevice] = useState(null);

    useEffect(() => {
        if (locationId !== activeKey)
            return;
        if (devices.length > 0) {
            setSelectedDevice(devices[0]);
        }
    }, [devices]);

    if (locationId !== activeKey)
        return <></>

    const handleDeviceClick = (device) => {
        setSelectedDevice(device);
    }
    const getDeviceParameterData = (device) => {
        if (device === null) return <div>No data</div>
        const dataList = [];
        for (let [key, value] of Object.entries(device)) {
            if (typeof value === "boolean") {
                value = value ? "on" : "off";
            }
            dataList.push(<tr>
                <td className={"first-letter-uppercase"}>{letterSpace(key)}</td>
                <td>{value}</td>
            </tr>)
        }
        return dataList.map(item => item)
    }
    const handleDeviceEdit = (device) => {
        dispatch(setDevice(device));
        dispatch(openModal());
    }
    const handleDeviceDelete = () => {
        dispatch(setDeleteModalStatus(true))
    }
    const handleDeviceCreate = () => {
        dispatch(openModal());
    }
    const handleConfirmationModalClose = () => {
        dispatch(setDeleteModalStatus(false))
    }
    const handleDeleteConfirmationSubmit = () => {
        dispatch(deleteDevice({
            installationId: installation.value,
            locationId: locationId,
            deviceId: selectedDevice.id
        }));
    }
    return (
        <>
            <ConfirmationModal show={showConfirmationModal} onClose={handleConfirmationModalClose}
                               onSubmit={handleDeleteConfirmationSubmit}
                               text={"Da li ste sigurni da želite obrisati ovaj uređaj?"}/>
            <DeviceModal locationId={locationId} deviceId={selectedDevice?.id}/>
            <div className={"d-flex justify-content-between"}>
                {loading ? <AppLoader/> : <>
                    <Card style={{width: "30%"}}>
                        <Card.Header className={"d-flex justify-content-between align-items-center"}>
                            <div><span>Uređaji</span></div>
                            <div className={"device-add-icon"} onClick={handleDeviceCreate}><img src={PlusIcon}
                                                                                                 width={25}
                                                                                                 height={25}/></div>
                        </Card.Header>
                        <Card.Body style={{padding: "0px"}}>
                            <div className={"w-100"}>
                                <div className={"device-info"}>
                                    {devices.map(item =>
                                        <div onClick={handleDeviceClick.bind(this, item)}
                                             className={`d-flex justify-content-between align-items-center device-model${selectedDevice !== null && selectedDevice.id === item.id ? "-active" : ""}`}>
                                            <div>
                                                <span>{item.model}</span>
                                            </div>
                                            <div>
                                                <Dropdown align="end">
                                                    <Dropdown.Toggle as={CustomDropDownToggle}
                                                                     id="dropdown-custom-components">
                                                        <img src={ellipsis} width={5} height={15} className={"ms-2"}/>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item eventKey="1" className={"update-button-card"}
                                                                       onClick={handleDeviceEdit.bind(this, item)}>
                                                            <AiFillEdit/> Izmjeni
                                                        </Dropdown.Item>
                                                        <Dropdown.Item eventKey="2" className={"delete-button-card"}
                                                                       onClick={handleDeviceDelete.bind(this, selectedDevice)}>
                                                            <RiDeleteBin6Line/> Obriši
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card style={{width: "65%"}}>
                        <Card className={"b-unset"}>
                            <Card.Header className={"card-title-location"}>Detalji
                                uređaja: {selectedDevice !== null ? selectedDevice.model : ""}</Card.Header>
                            <Card.Body className={"card-body-location"}>
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th scope="col">Naziv polja</th>
                                        <th scope="col">Vrijednost</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {getDeviceParameterData(selectedDevice)}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    </Card>
                </>}
            </div>
        </>

    );
};

export default DeviceAccordionBody;